// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","MorePosts__posts":"ph_a bhs_rc bhs_qx bhs_xr"};